module.exports = __webpack_public_path__ + "static/shopify-e35ab1110f267d05c8281be70b8038ac.png";